// @flow

/** Navigates to the specified URL; mockable in jsdom */
export const navigateTo = (url: string): void => window.location.assign(url);
